import React from 'react';
import { LoggedCandidate } from '../models/LoggedCandidate';
import { LoggedRecruiter } from '../models/LoggedRecruiter';
import CryptoJS from 'crypto-js';

export interface AuthContextType {
    setLoggedCandidate(loggedCandidate:any, token?: string): any;        
    getLoggedCandidate(): any;
    setLoggedRecruiter(loggedRecruiter:any, token: string): any;    
    getLoggedRecruiter(): any;
}

export const AuthContext = React.createContext<AuthContextType>({ 
    setLoggedCandidate: () => {},       
    getLoggedCandidate: () => {},
    setLoggedRecruiter: () => {},
    getLoggedRecruiter: () => {}
});

export const AuthContextProvider: React.FC = (props) => {    

    const setCandidate = (loggedCandidate: any, token?: string) => {
        const candidateString = JSON.stringify(loggedCandidate);
        const encryptedCandidateString = CryptoJS.AES.encrypt(candidateString, "").toString();
        localStorage.setItem('candidate', encryptedCandidateString);    
        localStorage.setItem('savedJobIds', JSON.stringify(loggedCandidate.savedJobIds)); 
        if(token) {  
            localStorage.setItem('token', token);   
        } 
    }

    const getCandidate = (): LoggedCandidate | null => {           
        const candidateString = localStorage.getItem("candidate"); 
        const token = localStorage.getItem("token");           
        if(candidateString !== null) {
            const decryptedCandidateString = CryptoJS.AES.decrypt(candidateString, "").toString(CryptoJS.enc.Utf8);            
            const candidate = JSON.parse(decryptedCandidateString);
            candidate.token = token;
            return candidate;
        } else {
            return null;
        }       
    }

    const setRecruiter = (loggedRecruiter:any, token: string) => {
        const recruiterString = JSON.stringify(loggedRecruiter);
        const encryptedRecruiterString = CryptoJS.AES.encrypt(recruiterString, "").toString();
        localStorage.setItem('recruiter', encryptedRecruiterString); 
        localStorage.setItem('token', token); 
    }

    const getRecruiter = (): LoggedRecruiter | null => {        
        const recruiterString = localStorage.getItem("recruiter"); 
        const token = localStorage.getItem("token");
        if(recruiterString !== null) {
            const decryptedRecruiterString = CryptoJS.AES.decrypt(recruiterString, "").toString(CryptoJS.enc.Utf8);            
            const recruiter = JSON.parse(decryptedRecruiterString);
            recruiter.token = token;
            return recruiter;
        } else {
            return null;
        }       
    }

    return (
        <AuthContext.Provider value={{     
            setLoggedCandidate: setCandidate,                   
            getLoggedCandidate: getCandidate,
            setLoggedRecruiter: setRecruiter,
            getLoggedRecruiter: getRecruiter
        }}>           
            {props.children}
        </AuthContext.Provider>
    );
}